import { FeatureFlag } from '@mkp/debug/models';
import { createSelector } from '@ngrx/store';
import { debugFeature, DebugState, getInitialState } from './debug.reducer';

export const selectFeatureFlags = createSelector(
  debugFeature.selectDebugStateState,
  (state: DebugState) => {
    const { defaultFlags, featureFlagOverrides, isLocked } = state ?? getInitialState();

    return isLocked ? defaultFlags : { ...defaultFlags, ...featureFlagOverrides };
  }
);

export const selectFeatureFlag = (featureFlag: FeatureFlag) =>
  createSelector(selectFeatureFlags, (featureFlags) => Boolean(featureFlags[featureFlag]));

export const selectIsEditMode = createSelector(
  debugFeature.selectDebugStateState,
  (state: DebugState) => state.editMode
);

export const selectIsDefault = selectFeatureFlag('default');

export const selectIsMissingTranslationsEnabled = selectFeatureFlag('missingTranslations');

export const selectIsKeepMenusOpen = selectFeatureFlag('keepMenusOpen');

export const selectIsRouterTracingEnabled = selectFeatureFlag('routerTracingEnabled');

export const selectIsInvoiceEnabled = selectFeatureFlag('isInvoiceEnabled');

export const selectIsNewVacancyPreviewUI = selectFeatureFlag('isNewPreviewUI');

export const selectIsGenerateAbandonedLinkEnabled = selectFeatureFlag(
  'isGenerateAbandonedLinkEnabled'
);

export const selectIsNewAccountManagement = selectFeatureFlag('isNewAccountManagementEnabled');

export const selectTealiumFlags = createSelector(selectFeatureFlags, (featureFlags) => ({
  trackingLink: featureFlags.trackingLink,
  trackingView: featureFlags.trackingView,
  trackingClick: featureFlags.trackingClick,
}));

export const selectIsNewSalaryDesign = selectFeatureFlag('isNewSalaryDesign');
export const selectisPublicationPPPFeatureEnabled = selectFeatureFlag(
  'isPublicationPPPFeatureEnabled'
);
export const selectIsPayPerInviteEnabled = selectFeatureFlag('isPayPerInviteEnabled');
export const selectIsMultipleWorkLocationsEnabled = selectFeatureFlag(
  'isMultipleWorkLocationsEnabled'
);

export const selectIsVBPEnabled = selectFeatureFlag('isVBPEnabled');

export const selectIsVBPMockProductsEnabled = selectFeatureFlag('isVBPMockProductsEnabled');

export const selectIsTeachableWidgetEnabled = selectFeatureFlag('isTeachableWidgetEnabled');

export const selectIsSocialProfilesEnabled = selectFeatureFlag('isSocialProfilesEnabled');
